import { gql } from "@apollo/client";
import { getComponeycodeID } from "../../../../../CommonFunction/GetUserInfo";

export const GetBranches = gql`
  query SearchBranchWithCompanyId($SearchId: ID) {
    SearchBranchWithCompanyId(Company_ID: $SearchId) {
      _id
      Name
      Branch_Code
      City
      Unique_Id
      Search_Value
      Company_ID
    }
  }
`;

const PodManagementData = [
  {
    id: Math.random() * 10,

    name: "POD_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Booking_Id",
        label: "Booking ID",
        type: "text",
      },
      {
        id: Math.random() * 10,
        name: "Driver_Name",
        label: "Driver Name",
        type: "text",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Driver_Number",
        label: "Driver Number",
        type: "number",
        min: 10,
        max: 10,
      },
      {
        id: Math.random() * 10,
        name: "LoadId",
        label: "Load",
        type: "text",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "UserId",

        label: "User Name",
        type: "text",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Vehicle_Number",
        label: "Vehicle Number",
        type: "text",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "LR_No",
        label: "LR Number",
        type: "text",
        min: 0,
        max: Infinity,
      },
    ],
  },
  {
    id: Math.random() * 10,
    name: "Collection_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Collected_Date",
        label: "Collected Date",
        type: "Date",
      },
      {
        id: Math.random() * 10,
        name: "Collected_By",
        label: "Collected By",
        type: "text",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Branch",
        label: "Branch ",

        type: "InputDropForQuery",
        masterName: "Branch",
        dropdowndata: GetBranches,
        Reference_field: "CompId",
        min: 0,
        max: Infinity,

        variable: {
          companyId: getComponeycodeID(),
        },
      },
      {
        id: Math.random() * 10,
        name: "Damage_Or_Breakage",
        label: "Breakage",
        type: "text",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Shortage",
        label: "Shortage",
        type: "text",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Leakage",
        label: "Leakage",
        type: "text",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Remark",
        label: "Remark",
        type: "inputdrop",
        dropdowncontent: ["Remark1", "Remark2"],
      },
      {
        id: Math.random() * 10,
        name: "Note",
        label: "Notes",
        masterSearch: true,
        type: "textarea",
      },
    ],
  },
  {
    name: "Other_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Upload Image",
        label: "Upload Image",
        Imagefileds: [
          {
            id: Math.random() * 10,
            name: "POD_Copy_Front",
            label: "POD Front",
          },
          {
            id: Math.random() * 10,
            name: "POD_Copy_Back",
            label: "POD Back",
          },
          {
            id: Math.random() * 10,
            name: "Invoice_Copy",
            label: "Invoice",
          },
          {
            id: Math.random() * 10,
            name: "POD_Scan_Copy_Front",
            label: "POD Front Scan Back",
          },
          {
            id: Math.random() * 10,
            name: "POD_Scan_Copy_Back",
            label: "POD Back Scan Back",
          },
        ],
      },
    ],
  },
];
export default PodManagementData;
